"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_2 = require("@osmosys/react");
const hooks_1 = require("../../hooks");
const reactstrap_1 = require("reactstrap");
const change_case_1 = require("change-case");
const reusables_1 = require("../../../../comps/reusables");
const inputs_1 = require("../../../../inputs");
const react_if_1 = require("react-if");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
exports.ConversionStepCanvasField = ({ fieldId, isLast, type, options, label, helpText, }) => {
    const { data } = hooks_1.useConversionStepCanvasData();
    const { update } = hooks_1.useConversionStepCanvasUpdate();
    const foundVal = data[fieldId];
    const val = type === 'number'
        ? typeof foundVal === 'number'
            ? foundVal
            : null
        : typeof foundVal === 'string'
            ? foundVal
            : '';
    const displayFieldName = react_1.useMemo(() => {
        return label || change_case_1.sentenceCase(fieldId);
    }, [fieldId]);
    const inputProps = {
        name: fieldId,
        onChange: (e) => {
            update({
                [fieldId]: e.target.value,
            });
        },
        value: val,
    };
    const comp = type === 'select' ? (react_1.default.createElement(reusables_1.SelectBox, { options: options, value: (options || []).find(opt => opt.value === foundVal), onChange: opt => {
            update({
                [fieldId]: opt.value,
            });
        } })) : type === 'ad' ? (react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, { resource: "ad", value: foundVal, label: false, onChange: (newAd) => {
            update({
                [fieldId]: newAd,
            });
        } })) : //   <AdSelectBox
        //     value={foundVal as Ad}
        //     showLabel={false}
        //   />
        type === 'selector' ? (react_1.default.createElement(reactstrap_1.Input, Object.assign({}, inputProps))) : type === 'code' ? (react_1.default.createElement(reactstrap_1.Input, Object.assign({ type: "textarea" }, inputProps, { rows: 3 }))) : type === 'number' ? (react_1.default.createElement(reactstrap_1.Input, Object.assign({}, inputProps, { type: "text", onChange: ({ target }) => {
                update({
                    [fieldId]: target.value,
                });
            } }))) : type === 'checkbox' ? (react_1.default.createElement(reactstrap_1.CustomInput, Object.assign({ type: "switch", name: name, checked: foundVal === true, bsSize: "lg" }, inputProps, { id: `form-${type}-${fieldId}`, value: undefined, onChange: e => {
                update({
                    [fieldId]: e.target.checked,
                });
            } }))) : (react_1.default.createElement(reactstrap_1.Input, Object.assign({}, inputProps)));
    return (react_1.default.createElement(react_2.OsmosysDiv, { marginBottom: isLast, marginLeft: true, marginRight: true, marginTop: true, flexRowCenteredFilled: true },
        react_1.default.createElement(react_2.OsmosysDiv, { flexColCenteredFilled: true },
            react_1.default.createElement(reactstrap_1.Label, { className: "text-muted" },
                displayFieldName,
                react_1.default.createElement(react_if_1.When, { condition: !!helpText },
                    ' ',
                    react_1.default.createElement("sup", null,
                        react_1.default.createElement(react_2.OsmosysTooltip, { label: helpText, span: true, interactive: true },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faInfoCircle }))))),
            comp)));
};
//# sourceMappingURL=index.js.map